export const navbarHeight = 48;